import React, { useContext, useEffect, useState } from 'react';
import { Upload, List } from 'lucide-react';
import MainLayout from '../layout/MainLayout';
import CenterLayout from '../layout/CenterLayout';
import AppContext from '../Context/AppContext';
import UserBackupImport from '../components/UserBackupImport';
import UserBackupList from '../components/UserBackupList';

const UserBackup = () => {
    const { setCurrentPage } = useContext(AppContext)
    const [tab, setTab] = useState('list')

    useEffect(() => { setCurrentPage('user_backup') }, [])

    return (
        <MainLayout>
            <CenterLayout>
                <div className='df gap1 mb2 ub-tabs'>
                    <button onClick={() => setTab('import')} className={`btn df aic gap1 ${tab === 'import' ? 'cs' : 'cw'} `}>
                        <Upload size={16} color='#fff' /> Upload CSV
                    </button>
                    <button onClick={() => setTab('list')} className={`btn df aic gap1 ${tab === 'list' ? 'cs' : 'cw'} `}>
                        <List size={16} color='#fff' /> Liste user backup
                    </button>
                </div>

                {tab === 'import' ? <UserBackupImport /> : <UserBackupList />}
            </CenterLayout>
        </MainLayout>
    );
};

export default UserBackup;
